import axios from "axios";
import * as Sentry from "@sentry/nextjs";

const axiosInstance = axios.create();

axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;

const getDataSummary = (data) => {
  if (!data) {
    return undefined;
  }

  if (typeof data === "string") {
    try {
      const parsedData = JSON.parse(data);
      return {
        type: "json_string",
        keys: Object.keys(parsedData),
      };
    } catch (error) {
      return {
        type: "string",
        length: data.length,
      };
    }
  }

  if (typeof data === "object") {
    return {
      type: Array.isArray(data) ? "array" : "object",
      keys: Object.keys(data),
    };
  }

  return { type: typeof data };
};

const getResponseSummary = (data) => {
  if (!data) {
    return undefined;
  }

  if (typeof data === "string") {
    return data.slice(0, 300);
  }

  if (typeof data === "object") {
    return {
      keys: Object.keys(data),
      result: data.result,
      message: data.message,
    };
  }

  return data;
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      Sentry.captureException(error, {
        tags: {
          type: status >= 500 ? "api_500_error" : "api_400_error",
          status,
          url: error.config?.url,
          method: error.config?.method,
        },
        extra: {
          request: {
            url: error.config?.url,
            method: error.config?.method,
            params: error.config?.params,
            data: getDataSummary(error.config?.data),
          },
          response: {
            status,
            data: getResponseSummary(error.response?.data),
          },
        },
      });
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
